import Reveal from './ui/Reveal';

export default function FinalCta() {
  return (
    <section className="navy-sec center">
      <div className="wrap">
        <Reveal as="span" className="eyebrow">
          Your LNG journey begins here
        </Reveal>

        <Reveal as="h2" className="h-sec">
          <span className="dim-2">Stop collecting information.</span>
          <br />
          Start thinking like an LNG professional.
        </Reveal>

        <Reveal as="p" className="lede narrow mt-m" style={{ marginInline: 'auto' }}>
          LNG Ready is where ambitious professionals build the confidence, technical judgment, and
          professional capability to perform at a higher level.
        </Reveal>

        <Reveal className="mt-l">
          <a className="btn btn-white btn-lg" href="#pricing">
            Become LNG Ready
          </a>
        </Reveal>
      </div>
    </section>
  );
}
